export const ACTIONS = {
  EXIT_CONTAINER: 'BASE__EXIT_CONTAINER',
  RESET_STATE: 'BASE__RESET_STATE',
};